import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  return (
    <header className="sticky top-0 z-50 bg-background-50 border-b border-background-200/70">
      <nav className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center gap-8">
            <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
              <span className="font-heading text-2xl text-primary-500 tracking-wide">黑料吃瓜网</span>
            </Link>
            <div className="hidden lg:flex items-center gap-1">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="px-3 py-2 text-sm text-foreground-700 hover:text-primary-500 hover:bg-primary-50 rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>
          <div className="flex items-center gap-3">
            <div className="hidden md:flex items-center gap-1 bg-background-100 rounded-lg px-3 py-2">
              <i className="ri-search-line text-foreground-400 w-4 h-4 flex items-center justify-center"></i>
              <input
                type="text"
                placeholder="搜索吃瓜内容..."
                className="bg-transparent text-sm text-foreground-700 placeholder-foreground-400 outline-none w-40"
              />
            </div>
            <Link
              to="/about"
              className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              关于我们
            </Link>
          </div>
        </div>
      </nav>
    </header>
  );
}